/* eslint-disable vue/no-v-html */
<template>
  <div id="app">
    <loading v-if="isUserLoading">
      Загрузка данных пользователя
    </loading>
    <div
      v-else
      class="h-100"
    >
      <div class="d-flex h-100">
        <Navbar v-if="isLogged" />
        <div class="flex-1 min-h-100 flex flex-col">
          <router-view :key="$route.path" class="flex-1 w-full router-view overflow-y-auto" />
          <AppVersion class="w-full mx-[auto]" />
        </div>
      </div>
      <TabPanel />
    </div>
    <vuedal />
    <modals />
    <v-toast-container :toasts="toasts" @close="hideToast" class="!z-[1200]" />


    <notifications
      :max="5"
      :width="'50%'"
      group="global-notifications"
      position="top center"
    >
      <template
        slot="body"
        slot-scope="props"
      >
        <div
          :class="{
            [props.item.type]: true
          }"
          class="vue-notify"
        >
          <div
            v-if="props.item.title"
            class="vue-notify__title"
          >
            {{ props.item.title }}
          </div>

          <div
            v-if="props.item.text"
            class="vue-notify__content"
            v-html="props.item.text"
          />

          <span
            class="vue-notify__close-link"
            @click="props.close"
          >
            &times;
          </span>
        </div>
      </template>
    </notifications>

    <Call v-if="!isUserLoading && isLogged" />

    <common-modal-container />
    <ai-chat-widget v-if="isLogged && widgetLoaded && isAdminLog" id="ai-chat-widget"></ai-chat-widget>
  </div>
</template>

<script>
import { mixinModals } from '@/mixins/mixinModals';
import { mapState } from 'vuex';
import { domain } from '@/helpers/utils';
import { ROLE } from '@/helpers/consts';

import Navbar from '@/components/Navbar';
import Call from '@/components/Call';
import TabPanel from '@/components/TabPanel';

import Loading from '@/components/Loading';
import Modals from '@/components/Modals';
import { Component as vuedal } from 'vuedals';
import CommonModalContainer from '@/components/common/CommonModalContainer.vue';
import { api } from '@/helpers/api';
import AppVersion from './components/base/AppVersion.vue';
import { VToastContainer } from '@gostelemed.front/rt-doctis.designsystem';


export default {
  name: 'App',
  components: {
    CommonModalContainer,
    Loading,
    vuedal,
    Modals,
    Navbar,
    TabPanel,
    Call,
    AppVersion,
    VToastContainer,
  },
  mixins: [mixinModals],
  computed: {
    ...mapState('UIStore', ['toasts']),
    isUserLoading() {
      return this.$store.state.Auth.isUserLoading;
    },
    isLogged() {
      return this.$store.state.Auth.token;
    },
    isAdminLog() {
      return this.$store.state.Auth.role === ROLE.GOV_ADMIN_LOG;
    },
  },
  data() {
    return {
      widgetLoaded: false,
    };
  },
  async mounted() {
    this.setFavicon();
    customElements.whenDefined('ai-chat-widget')
      .then(() => {
        this.widgetLoaded = true;

        if (this.isLogged) {
          this.getAiToken(this.isLogged);
        }
      })
      .catch(() => console.warn('ai-chat-widget не был загружен'));
    await this.$store.dispatch(this.$types.GET_APP_VERSION);
  },
  methods: {
    hideToast(toast) {
      this.$uiService.hideToastById(toast.id);
    },
    setFavicon() {
      const favicon = document.getElementById('favicon');
      const faviconUrl = `/${domain.favicon}.ico`;
      favicon.href = faviconUrl;
    },
    getAiToken(token) {
      const widgetId = 'ai-chat-widget';

      const setToken = () => {
        const el = document.getElementById(widgetId);
        if (!el) return false;
        el.apiToken = token || '';
        el.apiUrl = api.defaults.baseURL;
        return true;
      };

      if (!setToken()) {
        customElements.whenDefined(widgetId).then(() => setToken());
      }
    },
  },
  watch: {
    isLogged: {
      immediate: true,
      handler(newToken) {
        this.getAiToken(newToken);
      },
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: 'Inter';
}
#app {
  width: 100vw;
  min-width: 740px;
  height: 100vh;
  background-color: #f3f3f3;
  color: $black-light;
  font-size: 14px;
  line-height: 17px;
}
.router-view {
  min-height: calc(100% - 40px);
}
</style>
